<template>
    <div class="preloader">
        <img src="../assets/logo.png" alt="preloader">
        <p>{{ message || 'Загрузка' }}</p>
    </div>
</template>

<script>
    export default {
        name: "preloader",
        props: {
            // Подпись под крутилкой. Меняется по ходу долгой загрузки,
            // чтобы ожидание не выглядело зависанием
            message: { type: String, default: "" }
        }
    }
</script>

<style scoped lang="sass">
    @keyframes preloader
        0%
            transform: rotateZ(0deg)
        100%
            transform: rotateZ(360deg)
    .preloader
        img
            transition: all .5s linear
            animation: preloader 2s infinite linear
            height: 50px

</style>